'use strict';

angular.module('atex.art').factory('ArtPrintData',
  ['$q', '$http', '$route', '$rootScope', 'Application', 'ArtLayoutService', 'ArtContentStore',
    'CopyfitDialog', '$translate', '$injector',

      function($q, $http, $route, $rootScope, Application, ArtLayoutService, ArtContentStore,
               CopyfitDialog, $translate, $injector) {

      var printUtils;

      var getPrintUtils = function() {
        if (!printUtils) {
          printUtils = $injector.get('PrintUtils');
        }
        return printUtils;
      };

      var prestigeLinkage = 'aspects/prestige.ContentData/data/itemId';
      var hermesLinkage = 'aspects/hermesElements';

      var isLinkedContent = function (topDomainObject) {
        var domainObject = atex.onecms.DomainObjectUtils.getDomainObjectByPath(topDomainObject, prestigeLinkage);
        if(typeof domainObject !== 'undefined') {
          return domainObject.getData() > 0;
        }
        domainObject = atex.onecms.DomainObjectUtils.getDomainObjectByPath(topDomainObject, hermesLinkage);
        return typeof domainObject !== 'undefined';
      };

      var getPrintId = function (topDomainObject) {
        var domainObject = atex.onecms.DomainObjectUtils.getDomainObjectByPath(topDomainObject, prestigeLinkage);
        if(typeof domainObject !== 'undefined') {
          return domainObject.getData();
        }
        return 0;
      };

        var isArticleLinked = function (article) {
        var itemId = atex.onecms.ObjectUtils.getByPath(article, 'data/' + prestigeLinkage);
        if(typeof itemId !== 'undefined') {
          return itemId > 0;
        }
        var contentData = atex.onecms.ObjectUtils.getByPath(article, 'data/' + hermesLinkage);
        return typeof contentData !== 'undefined';
      };

      var getPrintVariantsDomainObject = function( topDomainObject ) {
        return atex.onecms.DomainObjectUtils.getDomainObjectByPath(topDomainObject, 'aspects/atex.PrintVariants/data');
      };

      var getChannelsContentDomainObject = function( topDomainObject ) {
        return atex.onecms.DomainObjectUtils.getDomainObjectByPath(topDomainObject, 'aspects/atex.ChannelContentData/data');
      };

      var getPrintVariantsByPath = function( article ) {
        return atex.onecms.ObjectUtils.getByPath(article, 'data/aspects/atex.PrintVariants');
      };

      var getPrintAttributesByPath = function( article ) {
        return atex.onecms.ObjectUtils.getByPath(article, 'data/aspects/atex.PrintVariants/data/attributes');
      };

      var getPrintAspectByPath = function( article ) {
        return atex.onecms.ObjectUtils.getByPath(article, 'data/aspects/atex.PrintVariants/data');
      };

      var CHANNEL_FLAG_DEFAULT = 0x00000000;
      var CHANNEL_FLAG_PRINT = 0x00000001;
      var CHANNEL_FLAG_DIGITAL = 0x00000002;
      var CHANNEL_FLAG_PRINT_PENDING = 0x00000004;

      var OPERATION_FLAG_NONE = 0x00000000;
      var OPERATION_FLAG_LOCK = 0x00000001;
      var OPERATION_FLAG_UNLOCK = 0x00000002;
      var OPERATION_FLAG_HAS_CHANGES = 0x00000004;
      var OPERATION_FLAG_DELETE_VARIANT = 0x00000008;
      var OPERATION_FLAG_UPDATE_STATUS = 0x00000010;
      var OPERATION_FLAG_CREATE = 0x00000020;
      var OPERATION_FLAG_SAVE = 0x00000040;


      var STATE_FLAG_NONE = 0x00000000;

      var RESULT_CODE_PERMISSION_DENIED = 13;

      var hasFlag = function(flags, flag) {
        /*jshint -W016 */
        return ((flags&flag) === flag);
        /*jshint +W016 */
      };

      var setFlag = function(flags, flag) {
        /*jshint -W016 */
        flags |= flag;
        /*jshint +W016 */
        return flags;
      };

      var clearFlag = function(flags, flag) {
        /*jshint -W016 */
        flags &= (~flag);
        /*jshint +W016 */
        return flags;
      };

      var hasPrintAttributes = function( article ) {
        if ( typeof $rootScope.contentSettings !== 'undefined' && !_.isEmpty( $rootScope.contentSettings.layoutCommands ) ) {
          return true;
        }

        var printDataAttributes = getPrintAttributesByPath(article);

        if ( containsPrintAttributes( printDataAttributes ) ) {
          return true;
        }

        var printAspect = getPrintAspectByPath(article);

        return ( printAspect && printAspect.shapeId );
      };

      function containsPrintAttributes( printDataAttributes ) {
        if ( typeof printDataAttributes === 'undefined' ) {
          return false;
        }

        var hasPrintData = false;

        printDataAttributes.forEach( function( printAttribute ) {
          if ( printAttribute.hasContent ) {
            hasPrintData = true;
          }
        });

        return hasPrintData;
      }

      var shouldSendPrintData = function(article) {
        var printPreviewDisabled = (atex.onecms.ObjectUtils.getByPath(article.template, 'printPreviewDisabled') === true);
        if (printPreviewDisabled) {
          return false;
        }
        var printData = getPrintVariantsByPath(article);

        if ( typeof printData === 'undefined' ) {
          return false;
        }

        if (!hasPrintAttributes( article ) ) {
          return false;
        }

        return true;
      };

      var hasLockedElements = function(article) {
        if ( !shouldSendPrintData(article) ) {
          return false;
        }

        var printDataAttributes = getPrintAttributesByPath(article);

        if ( typeof printDataAttributes === 'undefined' ) {
          return false;
        }

        for ( var attribute in printDataAttributes ) {
          var printAttribute = printDataAttributes[attribute];

          if (typeof printAttribute.operationFlags !== 'undefined') {
            if (hasFlag(printAttribute.operationFlags, OPERATION_FLAG_LOCK)) {
              return true;
            }
          }
        }

        return false;
      };

      var updateArticleAndResolve = function(articleInfo, deferred) {
        if ( articleInfo.articleChanged ) {
          ArtContentStore.put(articleInfo.article).then(function() {
            if (typeof articleInfo.onComplete === 'function') {
              articleInfo.onComplete();
            }

            deferred.resolve(articleInfo.article);
          });
        } else {
          if (typeof articleInfo.onComplete === 'function'){
            articleInfo.onComplete();
          }
          deferred.resolve(articleInfo.article);
        }
      };

      var flushPrintUpdates = function(article) {
        var articleInfo = {article: article, articleChanged: false};
        var deferred = $q.defer();

        if (!shouldSendPrintData( article ) ) {
          return $q.when(article);
        }

        updatePrintStatus(articleInfo).then(
          function(data) {
            return updatePrintData(articleInfo);
          },
          function(response) {
            // Error from updatePrintStatus.
            updateArticleAndResolve(articleInfo, deferred);
          }
        ).then(
          function(data) {
            return updatePrintDeleteData(articleInfo, deferred);
          },
          function(response) {
            // Error from updatePrintData.
            updateArticleAndResolve(articleInfo, deferred);
          }
        ).then(
            function(data) {
              return updatePrintLocks(articleInfo, deferred);
            },
            function(response) {
              // Error from updatePrintDeleteData.
              updateArticleAndResolve(articleInfo, deferred);
            }
        ).then(
          function(data) {
            // All complete
            updateArticleAndResolve(articleInfo, deferred);
          },
          function(response) {
            // Error from updatePrintLocks.
            updateArticleAndResolve(articleInfo, deferred);
          }
        );

        return deferred.promise;
      };

      function updatePrintStatus(articleInfo) {
        var layoutOptions = {userId: Application.currentUser.principalId, userName: Application.currentUser.username, save: false, unlock: false, status: true};
        return updatePrintOperation(articleInfo, layoutOptions, OPERATION_FLAG_UPDATE_STATUS);
      }

      function updatePrintData(articleInfo) {
        var layoutOptions = {userId: Application.currentUser.principalId, userName: Application.currentUser.username, save: true, unlock: false};
        return updatePrintOperation(articleInfo, layoutOptions, OPERATION_FLAG_SAVE);
      }

      function updatePrintLocks(articleInfo) {
        var layoutOptions = {userId: Application.currentUser.principalId, userName: Application.currentUser.username, save: false, unlock: true};
        return updatePrintOperation(articleInfo, layoutOptions, OPERATION_FLAG_UNLOCK);
      }

      function updatePrintDeleteData(articleInfo) {
        var layoutOptions = {userId: Application.currentUser.principalId, userName: Application.currentUser.username, save: false, unlock: false, delete:true};
        return updatePrintOperation(articleInfo, layoutOptions, OPERATION_FLAG_DELETE_VARIANT);
      }

      function updatePrintOperation(articleInfo, layoutOptions, inProgressFlag) {
        var content_id = articleInfo.article.meta.id;

        var printdata = {
          data: {
            _type: "atex.PrintVariants",
            attributes: []
          }
        };

        var printDataAttributes = getPrintAttributesByPath(articleInfo.article);

        for ( var attribute in printDataAttributes ) {
          var printAttribute = printDataAttributes[attribute];

          if (typeof printAttribute.inProgressFlags !== 'undefined') {
            if (hasFlag(printAttribute.inProgressFlags, inProgressFlag)) {
              printdata.data.attributes.push(printAttribute);
            }

            if ( inProgressFlag === OPERATION_FLAG_UNLOCK ) {
              // Clear any lock flags in progress, without taking any action on the print server.
              if (hasFlag(printAttribute.inProgressFlags, OPERATION_FLAG_LOCK)) {
                printAttribute.inProgressFlags = clearFlag(printAttribute.inProgressFlags, OPERATION_FLAG_LOCK);
              }
            }
          }
        }

        if (typeof printdata.data.attributes === 'undefined' || printdata.data.attributes.length === 0 ) {
          return $q.when(articleInfo.article);
        }

        var deferred = $q.defer();

        ArtLayoutService.content( { contentId: content_id, layoutOptions: layoutOptions, contentData: printdata } ).then( function( data ) {

          for ( var attribute in printdata.data.attributes ) {
            var printAttribute = printdata.data.attributes[attribute];
            printAttribute.inProgressFlags = clearFlag(printAttribute.inProgressFlags, inProgressFlag);

            if (inProgressFlag === OPERATION_FLAG_UNLOCK) {
              printAttribute.operationFlags = clearFlag(printAttribute.operationFlags, OPERATION_FLAG_LOCK);

              if ( layoutOptions.unlock && printAttribute.lockedLocally ) {
                printAttribute.lockedLocally = false;
                printAttribute.lockedBy = '';
                printAttribute.lockedAt = '';
              }
            }

            if (inProgressFlag === OPERATION_FLAG_SAVE) {
              printAttribute.operationFlags = clearFlag(printAttribute.operationFlags, OPERATION_FLAG_HAS_CHANGES);
            }

            articleInfo.articleChanged = true;
          }
          deferred.resolve(articleInfo.article);
        }, function(response) {
          deferred.resolve(articleInfo.article);
        });

        return deferred.promise;
      }

      var sendPrintData = function( options ) {
        var article = options.article;

        if ( typeof options.save === 'undefined' ) {
          options.save = true;
        }

        if ( typeof options.unlock === 'undefined' ) {
          options.unlock = true;
        }

        if ( !hasPrintAttributes( article ) ) {
          return $q.when(article);
        }

        var layoutOptions = {
          userId: Application.currentUser.principalId,
          userName: Application.currentUser.username,
          unlock: options.unlock,
          save: options.save,
          unload: options.unload
        };

        var deferred = $q.defer();
        var printDataDeferred = $q.defer();
        var isLinkedContent = isArticleLinked(article);

        if (typeof options.rootScope !== 'undefined' ) {
          if (!$rootScope.xAttributeController) {
            updateArticleAndResolve({
              article: article,
              articleChanged: false,
              onComplete: options.onComplete
            }, deferred);
          } else {
            options.rootScope.$broadcast('copyfit:printDataRequest', 'savePrintData', layoutOptions, isLinkedContent, printDataDeferred);
            printDataDeferred.promise.then(function (articleChanged) {
              var topDomainObject = options.topDomainObject;

              if (articleChanged) {
                options.article.data = topDomainObject.pack();
              }

              updateArticleAndResolve({
                article: article,
                articleChanged: articleChanged,
                onComplete: options.onComplete
              }, deferred);
            }, function (response) {
              console.log("sendPrintData failed ");
              console.log("sendPrintData response = ", response);

              var processSendError = function () {
                if (response.status === 401 || response.status === 403) {
                  return processSendAccessDeniedError();
                } else if (response.status < 200 || response.status >= 300) {
                  return processServerUnavailableSendError();
                }

                return deferred.reject(atex.onecms.error.Error({
                  origin: 'Contributor Tool Detail View Controller',
                  type: atex.onecms.error.types.SERVER_ERROR,
                  severity: atex.onecms.error.severities.CRITICAL,

                  cause: "Can not send print data for '" + $route.current.params.id + "' to Print Server..."
                }));
              };

              var processSendAccessDeniedError = function () {
                return $translate([
                  "COPYFIT_ERROR_SAVING_PRINT_CONTENT",
                  "COPYFIT_ACCESS_DENIED",
                  "COPYFIT_NOT_AUTHORISED",
                  "COPYFIT_ARE_YOU_SURE",
                  "OK_BTN", "CANCEL_BTN"
                ]).then(function (translations) {
                  var dialogBody;
                  var username = Application.currentUser.username;

                  if (response.status === 403) {
                    dialogBody = translations.COPYFIT_ACCESS_DENIED;
                  } else {
                    var contentId = $route.current.params.id;
                    dialogBody = translations.COPYFIT_ACCESS_DENIED;
                  }
                  /* jshint -W061 */
                  dialogBody = eval('`' + dialogBody + '`') + " " + translations.COPYFIT_ARE_YOU_SURE;
                  /* jshint +W061 */

                  var modalOptions = {
                    confirmHeader: translations.COPYFIT_ERROR_SAVING_PRINT_CONTENT,
                    confirmBody: dialogBody,
                    buttons: [
                      {
                        label: translations.CANCEL_BTN, click: function () {
                          return deferred.resolve(article);
                        }, default: true, dismiss: true
                      },
                      {
                        label: translations.OK_BTN, click: function () {
                          if (typeof options.onComplete === 'function') {
                            options.onComplete();
                          }
                          return deferred.resolve(article);
                        }, dismiss: true
                      }
                    ]
                  };

                  CopyfitDialog.showModal(modalOptions);
                  return deferred.promise;
                });
              };

              var processServerUnavailableSendError = function () {
                var modalOptions;
                var doOptionCallbacks = function (options) {
                  if (typeof options.onComplete === 'function') {
                    options.onComplete();
                  }
                };

                var showErrorModal = function () {
                  if (typeof options.rootScope !== 'undefined' && !options.rootScope.printOfflineAcknowledged) {
                    CopyfitDialog.showModal(modalOptions);

                    return deferred.promise;
                  }
                  doOptionCallbacks(options);
                  updateArticleAndResolve({article: article, articleChanged: false}, deferred);
                };

                return $translate([
                  "COPYFIT_ERROR_SAVING_PRINT_CONTENT",
                  "COPYFIT_PRINT_SERVER_NOT_AVAILABLE",
                  "OK_BTN", "CANCEL_BTN"
                ]).then(function (translations) {

                  modalOptions = {
                    confirmHeader: translations.COPYFIT_ERROR_SAVING_PRINT_CONTENT,
                    confirmBody: translations.COPYFIT_PRINT_SERVER_NOT_AVAILABLE,
                    buttons: [
                      {
                        label: translations.CANCEL_BTN, click: function () {
                          updateArticleAndResolve({article: article, articleChanged: false}, deferred);
                        }, default: true, dismiss: true
                      },
                      {
                        label: translations.OK_BTN, click: function () {
                          doOptionCallbacks(options);
                          options.rootScope.$broadcast('copyfit:printOfflineAcknowledged', true);
                          updateArticleAndResolve({article: article, articleChanged: false}, deferred);
                        }, dismiss: true
                      }
                    ]
                  };

                  if (typeof options.rootScope !== 'undefined' && !options.rootScope.printOffline) {
                    options.rootScope.$broadcast('copyfit:printServerOffline', true);
                  }

                  return showErrorModal();
                });
              };

            });
          }
        }

        return deferred.promise;
      };


      var getOpenedInEditorDomainObject = function( topDomainObject, openedInEditorPath ) {
        return atex.onecms.DomainObjectUtils.getDomainObjectByPath(topDomainObject, 'aspects/' + openedInEditorPath);
      };

      function isOpenedInEditor( topDomainObject, initialiseFromPrintPath ) {
        var isInitialised = false;
        var contentDataDo = getOpenedInEditorDomainObject(topDomainObject, initialiseFromPrintPath);

        if ( contentDataDo ) {
          var contentData = contentDataDo.getData();

          isInitialised = contentData  ? contentData : false;
        }
        return isInitialised;
      }

      function setOpenedInEditor( topDomainObject, openedInEditorPath ) {
        if ( !isOpenedInEditor( topDomainObject ) ) {
          var contentDataDo = getOpenedInEditorDomainObject(topDomainObject, openedInEditorPath);

          if (contentDataDo) {
            contentDataDo.setData(true);
            contentDataDo.changed();
          }
        }
      }

      function updateAttributesFromPrint( topDomainObject, printVariantsDomainObject ) {
        var copyfitConfig = getPrintUtils().getCopyfitConfig();

        if ( !copyfitConfig || copyfitConfig.initialiseFromPrint.contentPath === '' ) {
          return true;
        }

        if ( isOpenedInEditor(topDomainObject, copyfitConfig.initialiseFromPrint.contentPath) ) {
          return false;
        }

        if ( copyfitConfig.initialiseFromPrint.enabled && typeof printVariantsDomainObject !== 'undefined' ) {
          var printAttributes = printVariantsDomainObject.getAttributes();

          printAttributes.forEach(function (printAttribute) {
            if (printAttribute.hasContent) {
              var printAttributeDo = atex.onecms.DomainObjectUtils.getDomainObjectByPath(topDomainObject, 'aspects/contentData/data/' + printAttribute.attribute);

              if (printAttributeDo) {
                printAttributeDo.setData(getPrintUtils().printToWeb(printAttribute.content));
                printAttributeDo.changed();
              }
            }
          });
        }

        setOpenedInEditor(topDomainObject, copyfitConfig.initialiseFromPrint.contentPath);

        return true;
      }

      var fetchPrintData = function(options) {
        var topDomainObject = options.topDomainObject;
        var newArticle = options.newArticle;
        var isLinked = isLinkedContent( topDomainObject );
        var printVariantsDomainObject = getPrintVariantsDomainObject( topDomainObject );
        var channelsContentDomainObject = getChannelsContentDomainObject( topDomainObject );

        if (options.printPreviewDisabled) {
          return $q.when(topDomainObject);
        }

        var processFetchAccessDeniedError = function(transportResponse, appResponse) {
          return $translate([
            "COPYFIT_ERROR_FETCHING_PRINT_CONTENT",
            "COPYFIT_ACCESS_DENIED",
            "COPYFIT_NOT_AUTHORISED",
            "COPYFIT_ARE_YOU_SURE",
            "OK_BTN", "CANCEL_BTN"
          ]).then(function(translations) {
            var dialogBody;
            var username = Application.currentUser.username;
            var bUnAuthorised = ((transportResponse === 401) || appResponse === RESULT_CODE_PERMISSION_DENIED);

            if (bUnAuthorised) {
              var contentId = $route.current.params.id;
              dialogBody = translations.COPYFIT_NOT_AUTHORISED;
            } else {
              dialogBody = translations.COPYFIT_ACCESS_DENIED;
            }
            /* jshint -W061 */
            dialogBody = eval('`' + dialogBody + '`');
            /* jshint +W061 */

            var buttons = [];
            if (!bUnAuthorised) {
              buttons.push(                  {
                  label: translations.CANCEL_BTN, click: function () {
                    return deferred.resolve(topDomainObject);
                  }, default: true, dismiss: true
                }
              );
            }
            buttons.push(                {
                label: translations.OK_BTN, click: function () {
                  if (typeof options.onComplete === 'function') {
                    options.onComplete();
                  }
                  if (typeof options.abortEditing === 'function') {
                    options.abortEditing();
                  }
                  return deferred.resolve(topDomainObject);
                }, default: true, dismiss: true
              }
            );

            var modalOptions = {
              confirmHeader: translations.COPYFIT_ERROR_FETCHING_PRINT_CONTENT,
              confirmBody: dialogBody,
              buttons: buttons
            };

            CopyfitDialog.showModal(modalOptions);

            return deferred.promise;
          });
        };

        if ( typeof printVariantsDomainObject !== 'undefined' && typeof channelsContentDomainObject !== 'undefined' && channelsContentDomainObject.hasChannel('Print') && !isLinked) {
          console.info("INFO: Rebuilding 'atex.PrintVariants' ascpect from 'atex.ChannelContentData' aspect");
          channelsContentDomainObject.getChannel('Print').initPrintVariant(printVariantsDomainObject);
          channelsContentDomainObject.removeChannel('Print');

          updateAttributesFromPrint( topDomainObject, printVariantsDomainObject );

          if( typeof options.saveArticle === 'function' ) {
            options.saveArticle(false, topDomainObject.pack());
          }

          if(typeof options.clearFresh === 'function') {
            options.clearFresh();
          }

          return $q.when(topDomainObject);
        }

        var checkAccessPermision = function() {
          var deferred = $q.defer();
          var permissionCheckOptions = {
            contentId: $route.current.params.id,
            subType: 'permission',
            permission: 'WRITE',
            layoutOptions: {
              userId: Application.currentUser.principalId,
              userName: Application.currentUser.username,
              printId: getPrintId(topDomainObject)
            }
          };

          ArtLayoutService.content( permissionCheckOptions ).then(function() {
            return deferred.resolve();
          }, function (response) {
            if (response.status === 401 || response.status === 403) {
              return processFetchAccessDeniedError(response.status, RESULT_CODE_PERMISSION_DENIED);
            }
            return deferred.resolve();
          });
          return deferred.promise;
        };

        if ( typeof printVariantsDomainObject === 'undefined' || !isLinked || newArticle === true ) {
          updateAttributesFromPrint( topDomainObject, printVariantsDomainObject );
          if(isLinked && getPrintUtils().getCopyfitConfig().alwaysCheckPermission) {
            return checkAccessPermision();
          }
          return $q.when();
        }

        if ( typeof options.actReloaded === 'undefined' ) {
          options.actReloaded = false;
        }

        if ( typeof options.lock === 'undefined' ) {
          options.lock = true;
        }

        var deferred = $q.defer();

        var layoutOptions = {
          userId: Application.currentUser.principalId,
          userName: Application.currentUser.username,
          lock: options.lock
        };

        ArtLayoutService.content( { contentId: $route.current.params.id, layoutOptions: layoutOptions } ).then( function( data ) {

          if (typeof options.rootScope !== 'undefined' && options.rootScope.printOffline) {
            options.rootScope.$broadcast('copyfit:printServerOffline', false);
          }

          var auxData = atex.onecms.ObjectUtils.getByPath(data, 'atex.PrintVariants/data/auxData');

          if ( auxData ) {
            var auxDataObj = JSON.parse( auxData );

            if ( auxDataObj.resultCode && auxDataObj.resultCode === RESULT_CODE_PERMISSION_DENIED ) {
              return processFetchAccessDeniedError(0, auxDataObj.resultCode);
            }
          }

          var reconcileResult = printVariantsDomainObject.reconcileArticle(data);

          if ( updateAttributesFromPrint( topDomainObject, printVariantsDomainObject ) ) {
            reconcileResult.shouldSaveArticle = true;
          }

          if (reconcileResult.shouldSaveArticle && typeof options.saveArticle === 'function') {
            options.saveArticle(false, topDomainObject.pack());
          }

          if (printVariantsDomainObject.articleHasOperationFlag(OPERATION_FLAG_HAS_CHANGES) && typeof options.clearFresh === 'function') {
            options.clearFresh();
          }

          return deferred.resolve(topDomainObject);
        }, function(response) {
          console.log("loadPrintData response = ", response);

          var processFetchError = function() {

            if (response.status === 401 || response.status === 403) {
              return processFetchAccessDeniedError(response.status);
            }
            else if (response.status < 200 || response.status >= 300) {
              return processServerUnavailableError();
            }

            return deferred.reject(atex.onecms.error.Error({
              origin: 'Contributor Tool Detail View Controller',
              type: atex.onecms.error.types.SERVER_ERROR,
              severity: atex.onecms.error.severities.CRITICAL,

              cause: "Can not get print data for '" + $route.current.params.id + "' from Print Server..."
            }));
          };

          var processServerUnavailableError = function() {
            if (printVariantsDomainObject.articleHasOperationFlag(OPERATION_FLAG_HAS_CHANGES) && typeof options.clearFresh === 'function') {
              options.clearFresh();
            }
            if ( typeof options.rootScope !== 'undefined' && !options.rootScope.printOffline ) {
              options.rootScope.$broadcast('copyfit:printServerOffline', true);
            }

            if ( typeof options.rootScope !== 'undefined' && !options.rootScope.printOfflineAcknowledged ) {
              return $translate([
                "COPYFIT_ERROR_FETCHING_PRINT_CONTENT",
                "COPYFIT_ERROR_FETCHING_PRINT_CONTENT_BODY",
                "OK_BTN", "CANCEL_BTN"
              ]).then(function(translations) {

                var modalOptions = {
                  confirmHeader: translations.COPYFIT_ERROR_FETCHING_PRINT_CONTENT,
                  confirmBody: translations.COPYFIT_ERROR_FETCHING_PRINT_CONTENT_BODY,
                  buttons: [
                    {
                      label: translations.CANCEL_BTN, click: function () {
                      if (typeof options.abortEditing === 'function') {
                        options.abortEditing(true);
                      }
                      return deferred.resolve(topDomainObject);
                    }, default: true, dismiss: true
                    },
                    {
                      label: translations.OK_BTN, click: function () {
                      options.rootScope.$broadcast('copyfit:printOfflineAcknowledged', true);

                      return deferred.resolve(topDomainObject);
                    }, dismiss: true
                    }
                  ]
                };

                CopyfitDialog.showModal(modalOptions);
              });
            } else {
              return deferred.resolve(topDomainObject);
            }
            return deferred.promise;
          };

          return processFetchError();
        });

        return deferred.promise;
      };

      return {
        fetchPrintData: fetchPrintData,
        sendPrintData: sendPrintData,
        flushPrintUpdates: flushPrintUpdates,
        shouldSendPrintData: shouldSendPrintData,
        hasLockedElements: hasLockedElements
      };
    }
  ]);
